import React from 'react'
import { Input } from 'alurkerja-ui'

type EditDefaultProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditDefaultTime(props: EditDefaultProps) {
  const { index, element, currentElementState, setCurrentElementState } = props

  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{'Default Time'}</span>
      <Input
        type={'time'}
        size={'sm'}
        onChange={(e) => setCurrentElementState((prevState: any) => ({ ...prevState, [element]: e.target.value }))}
        defaultValue={currentElementState?.[element]}
      />
    </div>
  )
}
